import { merge } from "lodash";

import type { Permission } from "~/types/auth.type";

import { managerPermissions } from "./manager.constant";

export const managerBoilerRoomPermissions: Permission = merge<Permission, Permission>(
  JSON.parse(JSON.stringify(managerPermissions)) as Permission,
  {
    valve: {
      heatingNetworkId: { read: true },
    },
    module: {
      boilerroom: {
        read: true,
      },
      airHandlerUnit: {
        read: true,
      },
    },
    page: {
      boilerroom: true,
      airHandlerUnit: true,
      consumption: true,
      gtb: true,
    },
  },
);
